// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M9 1H4a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V5L9 1zm0 1.5L12.5 5H9V2.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.code_section {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.code_section__active_path {
    font-size: 11px;
    font-weight: 400;
    letter-spacing: 0;
    text-transform: none;
    color: var(--color-text-muted);
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    direction: rtl;
}

.accordion--horizontal .code_section__edit_toggle {
    order: -1;
}

.accordion--horizontal .code_section__active_path {
    max-width: none;
    max-inline-size: 120px;
}

.code_section__edit_toggle {
    font-size: 15px;
    color: var(--color-text);
    cursor: pointer;
    line-height: 1;
    padding: 2px 4px;
    border-radius: 3px;
    transition: color 0.15s, background-color 0.15s;
}

@media (pointer: fine) {
    .code_section__edit_toggle:hover {
        background-color: var(--color-bg-3);
    }
}

.code_section__edit_toggle--active {
    color: var(--color-accent);
}

.code_section__collapse_btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: 0;
    color: var(--color-text);
    cursor: pointer;
    line-height: 1;
    border-radius: 3px;
    transition: color 0.15s, background-color 0.15s;
}

@media (pointer: fine) {
    .code_section__collapse_btn:hover {
        background-color: var(--color-bg-3);
    }
}

.code_section__pane {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}

.code_section__pane--sidebar {
    background-color: var(--color-bg-2);
}

.code_section__placeholder {
    padding: 9px 13px;
    font-size: 13px;
    color: var(--color-text-muted);
}

.code_section__no_tabs {
    padding: 18px;
    font-size: 13px;
    color: var(--color-text-muted);
}

.code_section__file_content {
    flex: 1;
    margin: 0;
    padding: 13px 18px;
    overflow: auto;
    font-size: 14px;
    line-height: 1.5;
    white-space: pre;
    tab-size: 4;
}

.code_section__loading {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.code_section__loading_spinner {
    width: 22px;
    height: 22px;
    border: 2px solid var(--color-text-muted);
    border-top-color: transparent;
    border-radius: 50%;
    animation: code_section__spin 0.7s linear infinite;
}

@keyframes code_section__spin {
    to { transform: rotate(360deg); }
}

.code_section__pane_label {
    padding: 9px 13px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-text-muted);
    user-select: none;
    display: flex;
    align-items: center;
    gap: 8px;
}

.code_section__pane_label_text {
    flex-shrink: 0;
}

.code_section__pane_label .branch_select {
    flex: 1 1 0;
    min-width: 60px;
}

.code_section__dialog_btn {
    padding: 5px 14px;
    font-size: 13px;
    border-radius: 4px;
    border: 1px solid var(--color-border);
    background: var(--color-bg-3);
    color: var(--color-text);
    cursor: pointer;
    transition: background-color 0.1s;
}

@media (pointer: fine) {
    .code_section__dialog_btn:hover {
        background: var(--color-bg-2);
    }
}

.code_section__dialog_btn--primary {
    background: var(--color-accent, #3498db);
    border-color: var(--color-accent, #3498db);
    color: #fff;
}

@media (pointer: fine) {
    .code_section__dialog_btn--primary:hover:not(:disabled) {
        opacity: 0.85;
    }
}

.code_section__dialog_btn:disabled {
    opacity: 0.5;
    cursor: default;
}

.code_section__rename_input {
    width: 100%;
    box-sizing: border-box;
    padding: 6px 10px;
    font-size: 13px;
    border: 1px solid var(--color-border);
    border-radius: 4px;
    background: var(--color-bg-1, var(--color-bg));
    color: var(--color-text);
    outline: none;
}

.code_section__rename_input:focus {
    border-color: var(--color-accent, #3498db);
}

/* Markdown overlay toggle (top-right corner of editor area) */
.code_section__md_overlay {
    position: absolute;
    top: 46px; /* 38px tab bar + 8px gap */
    right: 8px;
    z-index: 100;
    display: flex;
    background: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 4px;
    overflow: hidden;
}

.code_section__md_btn {
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.6;
    color: var(--color-text-muted);
    background: none;
    border: none;
    cursor: pointer;
    transition: color 0.12s, background-color 0.12s;
    user-select: none;
}

@media (pointer: fine) {
    .code_section__md_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.code_section__md_btn--active {
    color: var(--color-text);
    background: var(--color-bg-3);
}

.code_section__save_btn--sep {
    border-left: 1px solid var(--color-border);
}

.code_section__save_btn:disabled {
    cursor: default;
    opacity: 0.7;
}

.code_section__context_btn {
    position: absolute;
    bottom: 12px;
    right: 12px;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid var(--color-border);
    background: var(--color-bg-2);
    color: var(--color-text-muted);
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.1s, color 0.1s, border-color 0.1s;
    z-index: 10;
}

.code_section__context_btn--active {
    background: color-mix(in srgb, var(--color-accent, #4a6cf7) 20%, var(--color-bg-2));
    border-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 60%, transparent);
    color: var(--color-accent, #4a6cf7);
}

@media (pointer: fine) {
    .code_section__context_btn:hover {
        background: var(--color-bg-3);
        color: var(--color-text);
        border-color: var(--color-border);
    }

    .code_section__context_btn--active:hover {
        background: color-mix(in srgb, var(--color-accent, #4a6cf7) 30%, var(--color-bg-2));
    }
}

.code_section__save_spinner {
    display: inline-block;
    width: 10px;
    height: 10px;
    border: 1.5px solid var(--color-text-muted);
    border-top-color: transparent;
    border-radius: 50%;
    animation: code_section__spin 0.6s linear infinite;
    vertical-align: middle;
}

/* Search pane */
.code_section__search_pane {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.code_section__search_input_wrap {
    padding: 6px 10px;
}

.code_section__search_input {
    width: 100%;
    box-sizing: border-box;
    padding: 5px 8px;
    font-size: 13px;
    border: 1px solid var(--color-border);
    border-radius: 3px;
    background: var(--color-bg-1, var(--color-bg));
    color: var(--color-text);
    outline: none;
}

.code_section__search_input:focus {
    border-color: var(--color-accent, #3498db);
}

.code_section__search_meta {
    padding: 2px 12px 6px;
    font-size: 11px;
    color: var(--color-text-muted);
}

.code_section__search_results {
    flex: 1;
    overflow-y: auto;
}

.code_section__search_hint {
    padding: 10px 12px;
    font-size: 13px;
    color: var(--color-text-muted);
}

.code_section__search_file_group {
    margin-bottom: 4px;
}

.code_section__search_file_header {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px 8px;
    cursor: pointer;
    user-select: none;
}

@media (pointer: fine) {
    .code_section__search_file_header:hover {
        background: var(--color-bg-3);
    }
}

.code_section__search_file_icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    background-color: var(--color-text-muted);
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
}

.code_section__search_file_name {
    font-size: 13px;
    font-weight: 500;
    color: var(--color-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
}

.code_section__search_file_dir {
    font-size: 11px;
    color: var(--color-text-muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
}

.code_section__search_match_badge {
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 600;
    padding: 1px 5px;
    border-radius: 10px;
    background: var(--color-accent, #3498db);
    color: #fff;
    line-height: 1.5;
}

.code_section__search_match_row {
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 2px 8px 2px 22px;
    cursor: pointer;
    font-size: 12px;
}

@media (pointer: fine) {
    .code_section__search_match_row:hover {
        background: var(--color-bg-3);
    }
}

.code_section__search_line_num {
    flex-shrink: 0;
    width: 28px;
    text-align: right;
    color: var(--color-text-muted);
    font-size: 11px;
    font-variant-numeric: tabular-nums;
}

.code_section__search_match_text {
    color: var(--color-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: monospace;
    font-size: 12px;
}

.code_section__browser_wrap {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.configure_vault_banner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px 13px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: var(--color-accent);
    background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 10%, var(--color-bg-2));
    border-top: 1px solid color-mix(in srgb, var(--color-accent, #4a6cf7) 25%, transparent);
    cursor: pointer;
    flex-shrink: 0;
    margin-top: auto;
    transition: background-color 0.15s;
}

@media (pointer: fine) {
    .configure_vault_banner:hover {
        background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 18%, var(--color-bg-2));
    }
}

/* One-line merge-in-progress notice above the file tree. */
.code_section__merge_banner {
    flex-shrink: 0;
    padding: 3px 10px;
    font-size: 11px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--color-danger, #e53e3e);
    background: color-mix(in srgb, var(--color-danger, #e53e3e) 10%, transparent);
    border-bottom: 1px solid color-mix(in srgb, var(--color-danger, #e53e3e) 25%, transparent);
}

.code_section__search_highlight {
    background: rgba(255, 200, 0, 0.35);
    color: inherit;
    border-radius: 2px;
    padding: 0 1px;
}
`, "",{"version":3,"sources":["webpack://./components/sections/CodeSection/s.code_section.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,OAAO;IACP,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,qCAAqC;IACrC,6BAA6B;IAC7B,wBAAwB;IACxB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,wCAAwC;IACxC,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,qCAAqC;IACrC,kBAAkB;IAClB,8CAA8C;IAC9C,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,8DAA8D;AAC9D;IACI,kBAAkB;IAClB,SAAS,EAAE,2BAA2B;IACtC,UAAU;IACV,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,+CAA+C;IAC/C,iBAAiB;AACrB;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,6BAA6B;IAC7B,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0DAA0D;IAC1D,WAAW;AACf;;AAEA;IACI,mFAAmF;IACnF,+EAA+E;IAC/E,mCAAmC;AACvC;;AAEA;IACI;QACI,6BAA6B;QAC7B,wBAAwB;QACxB,iCAAiC;IACrC;;IAEA;QACI,mFAAmF;IACvF;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,6BAA6B;IAC7B,kBAAkB;IAClB,kDAAkD;IAClD,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,qCAAqC;IACrC,kBAAkB;IAClB,8CAA8C;IAC9C,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,yCAAyC;IACzC,2DAAmN;IACnN,mDAA2M;IAC3M,8BAA8B;IAC9B,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,yBAAyB;IACzB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;IAC1B,yFAAyF;IACzF,uFAAuF;IACvF,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI;QACI,yFAAyF;IAC7F;AACJ;;AAEA,2DAA2D;AAC3D;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mCAAmC;IACnC,6EAA6E;IAC7E,0FAA0F;AAC9F;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".code_section {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n}\n\n.code_section__active_path {\n    font-size: 11px;\n    font-weight: 400;\n    letter-spacing: 0;\n    text-transform: none;\n    color: var(--color-text-muted);\n    max-width: 160px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    direction: rtl;\n}\n\n.accordion--horizontal .code_section__edit_toggle {\n    order: -1;\n}\n\n.accordion--horizontal .code_section__active_path {\n    max-width: none;\n    max-inline-size: 120px;\n}\n\n.code_section__edit_toggle {\n    font-size: 15px;\n    color: var(--color-text);\n    cursor: pointer;\n    line-height: 1;\n    padding: 2px 4px;\n    border-radius: 3px;\n    transition: color 0.15s, background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .code_section__edit_toggle:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.code_section__edit_toggle--active {\n    color: var(--color-accent);\n}\n\n.code_section__collapse_btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    font-size: 15px;\n    font-weight: normal;\n    letter-spacing: 0;\n    color: var(--color-text);\n    cursor: pointer;\n    line-height: 1;\n    border-radius: 3px;\n    transition: color 0.15s, background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .code_section__collapse_btn:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.code_section__pane {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n.code_section__pane--sidebar {\n    background-color: var(--color-bg-2);\n}\n\n.code_section__placeholder {\n    padding: 9px 13px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n\n.code_section__no_tabs {\n    padding: 18px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n\n.code_section__file_content {\n    flex: 1;\n    margin: 0;\n    padding: 13px 18px;\n    overflow: auto;\n    font-size: 14px;\n    line-height: 1.5;\n    white-space: pre;\n    tab-size: 4;\n}\n\n.code_section__loading {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.code_section__loading_spinner {\n    width: 22px;\n    height: 22px;\n    border: 2px solid var(--color-text-muted);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: code_section__spin 0.7s linear infinite;\n}\n\n@keyframes code_section__spin {\n    to { transform: rotate(360deg); }\n}\n\n.code_section__pane_label {\n    padding: 9px 13px;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n    user-select: none;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.code_section__pane_label_text {\n    flex-shrink: 0;\n}\n\n.code_section__pane_label .branch_select {\n    flex: 1 1 0;\n    min-width: 60px;\n}\n\n.code_section__dialog_btn {\n    padding: 5px 14px;\n    font-size: 13px;\n    border-radius: 4px;\n    border: 1px solid var(--color-border);\n    background: var(--color-bg-3);\n    color: var(--color-text);\n    cursor: pointer;\n    transition: background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .code_section__dialog_btn:hover {\n        background: var(--color-bg-2);\n    }\n}\n\n.code_section__dialog_btn--primary {\n    background: var(--color-accent, #3498db);\n    border-color: var(--color-accent, #3498db);\n    color: #fff;\n}\n\n@media (pointer: fine) {\n    .code_section__dialog_btn--primary:hover:not(:disabled) {\n        opacity: 0.85;\n    }\n}\n\n.code_section__dialog_btn:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.code_section__rename_input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 6px 10px;\n    font-size: 13px;\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    background: var(--color-bg-1, var(--color-bg));\n    color: var(--color-text);\n    outline: none;\n}\n\n.code_section__rename_input:focus {\n    border-color: var(--color-accent, #3498db);\n}\n\n/* Markdown overlay toggle (top-right corner of editor area) */\n.code_section__md_overlay {\n    position: absolute;\n    top: 46px; /* 38px tab bar + 8px gap */\n    right: 8px;\n    z-index: 100;\n    display: flex;\n    background: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.code_section__md_btn {\n    padding: 3px 10px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.6;\n    color: var(--color-text-muted);\n    background: none;\n    border: none;\n    cursor: pointer;\n    transition: color 0.12s, background-color 0.12s;\n    user-select: none;\n}\n\n@media (pointer: fine) {\n    .code_section__md_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.code_section__md_btn--active {\n    color: var(--color-text);\n    background: var(--color-bg-3);\n}\n\n.code_section__save_btn--sep {\n    border-left: 1px solid var(--color-border);\n}\n\n.code_section__save_btn:disabled {\n    cursor: default;\n    opacity: 0.7;\n}\n\n.code_section__context_btn {\n    position: absolute;\n    bottom: 12px;\n    right: 12px;\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    border: 1px solid var(--color-border);\n    background: var(--color-bg-2);\n    color: var(--color-text-muted);\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.1s, color 0.1s, border-color 0.1s;\n    z-index: 10;\n}\n\n.code_section__context_btn--active {\n    background: color-mix(in srgb, var(--color-accent, #4a6cf7) 20%, var(--color-bg-2));\n    border-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 60%, transparent);\n    color: var(--color-accent, #4a6cf7);\n}\n\n@media (pointer: fine) {\n    .code_section__context_btn:hover {\n        background: var(--color-bg-3);\n        color: var(--color-text);\n        border-color: var(--color-border);\n    }\n\n    .code_section__context_btn--active:hover {\n        background: color-mix(in srgb, var(--color-accent, #4a6cf7) 30%, var(--color-bg-2));\n    }\n}\n\n.code_section__save_spinner {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border: 1.5px solid var(--color-text-muted);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: code_section__spin 0.6s linear infinite;\n    vertical-align: middle;\n}\n\n/* Search pane */\n.code_section__search_pane {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n.code_section__search_input_wrap {\n    padding: 6px 10px;\n}\n\n.code_section__search_input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 5px 8px;\n    font-size: 13px;\n    border: 1px solid var(--color-border);\n    border-radius: 3px;\n    background: var(--color-bg-1, var(--color-bg));\n    color: var(--color-text);\n    outline: none;\n}\n\n.code_section__search_input:focus {\n    border-color: var(--color-accent, #3498db);\n}\n\n.code_section__search_meta {\n    padding: 2px 12px 6px;\n    font-size: 11px;\n    color: var(--color-text-muted);\n}\n\n.code_section__search_results {\n    flex: 1;\n    overflow-y: auto;\n}\n\n.code_section__search_hint {\n    padding: 10px 12px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n\n.code_section__search_file_group {\n    margin-bottom: 4px;\n}\n\n.code_section__search_file_header {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 8px;\n    cursor: pointer;\n    user-select: none;\n}\n\n@media (pointer: fine) {\n    .code_section__search_file_header:hover {\n        background: var(--color-bg-3);\n    }\n}\n\n.code_section__search_file_icon {\n    width: 14px;\n    height: 14px;\n    flex-shrink: 0;\n    background-color: var(--color-text-muted);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M9 1H4a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V5L9 1zm0 1.5L12.5 5H9V2.5z'/%3E%3C/svg%3E\");\n    mask-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M9 1H4a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V5L9 1zm0 1.5L12.5 5H9V2.5z'/%3E%3C/svg%3E\");\n    -webkit-mask-repeat: no-repeat;\n    mask-repeat: no-repeat;\n    -webkit-mask-size: contain;\n    mask-size: contain;\n}\n\n.code_section__search_file_name {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--color-text);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex-shrink: 0;\n}\n\n.code_section__search_file_dir {\n    font-size: 11px;\n    color: var(--color-text-muted);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;\n    min-width: 0;\n}\n\n.code_section__search_match_badge {\n    flex-shrink: 0;\n    font-size: 10px;\n    font-weight: 600;\n    padding: 1px 5px;\n    border-radius: 10px;\n    background: var(--color-accent, #3498db);\n    color: #fff;\n    line-height: 1.5;\n}\n\n.code_section__search_match_row {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    padding: 2px 8px 2px 22px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n@media (pointer: fine) {\n    .code_section__search_match_row:hover {\n        background: var(--color-bg-3);\n    }\n}\n\n.code_section__search_line_num {\n    flex-shrink: 0;\n    width: 28px;\n    text-align: right;\n    color: var(--color-text-muted);\n    font-size: 11px;\n    font-variant-numeric: tabular-nums;\n}\n\n.code_section__search_match_text {\n    color: var(--color-text);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-family: monospace;\n    font-size: 12px;\n}\n\n.code_section__browser_wrap {\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.configure_vault_banner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    padding: 8px 13px;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    color: var(--color-accent);\n    background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 10%, var(--color-bg-2));\n    border-top: 1px solid color-mix(in srgb, var(--color-accent, #4a6cf7) 25%, transparent);\n    cursor: pointer;\n    flex-shrink: 0;\n    margin-top: auto;\n    transition: background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .configure_vault_banner:hover {\n        background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 18%, var(--color-bg-2));\n    }\n}\n\n/* One-line merge-in-progress notice above the file tree. */\n.code_section__merge_banner {\n    flex-shrink: 0;\n    padding: 3px 10px;\n    font-size: 11px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: var(--color-danger, #e53e3e);\n    background: color-mix(in srgb, var(--color-danger, #e53e3e) 10%, transparent);\n    border-bottom: 1px solid color-mix(in srgb, var(--color-danger, #e53e3e) 25%, transparent);\n}\n\n.code_section__search_highlight {\n    background: rgba(255, 200, 0, 0.35);\n    color: inherit;\n    border-radius: 2px;\n    padding: 0 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
